import * as classnames from "classnames";

import { Checkbox, Form, FormGroup, JumpTo, Msg } from "@shared/components";
import { ApplicantChallengeModel } from "@shared/models";
import { ChallengeTakenBy } from "@shared/services/enums";
import Message from "@shared/services/message";

export type CodingCheckListPanelProps = {
  takenBy: ChallengeTakenBy;
  challenge: ApplicantChallengeModel;
  onChange: (formValid: boolean) => void;
};

const CHECK_ITEMS = {
  [`${ChallengeTakenBy.WebBrowser}`]: [
    {
      titleKey: "start-challenge.web.option1",
      subtitleKey: "start-challenge.web.option.linkToDoc",
      linkKey: "editor.link.coding.web",
    },
    {
      titleKey: "start-challenge.web.option2",
      subtitleKey: "start-challenge.web.option.linkToInstall",
      linkKey: "editor.link.coding.lib.install",
    },
  ],
  [`${ChallengeTakenBy.LocalMachine}`]: [
    {
      titleKey: "start-challenge.local.option4",
      subtitleKey: "start-challenge.local.option.linkToDoc",
      linkKey: "editor.link.coding.cli",
    },
    {
      titleKey: "start-challenge.local.option1",
      subtitleKey: "start-challenge.local.option.linkToInstall",
      linkKey: "editor.link.coding.cli.install",
    },
    {
      titleKey: "start-challenge.local.option3",
    },
    {
      titleKey: "start-challenge.local.option4",
    },
  ],
};

export const CodingCheckListPanel = (props: CodingCheckListPanelProps) => {
  const { takenBy } = props;

  const rootStyle = classnames("code-coding-checklist-panel");

  const onFormChange = (formValid: boolean, formValues: {}) => {
    props.onChange(
      Object.keys(formValues).filter((key) => formValues[key] === true)
        .length === CHECK_ITEMS[takenBy]?.length,
    );
  };

  return (
    <div className={rootStyle}>
      <Form
        onFormChange={onFormChange}
        initialValues={{}}
        validation={{}}
        clear={true}
        className="code-coding-checklist-panel__body"
      >
        <p>
          <Msg
            id={
              takenBy === ChallengeTakenBy.LocalMachine
                ? "start-challenge.local.option.text"
                : "start-challenge.web.option.text"
            }
          />
        </p>
        {CHECK_ITEMS[takenBy]?.map((item, index) => (
          <FormGroup key={index} className="code-coding-checklist-panel__item">
            <Checkbox
              className="code-coding-checklist-panel__check"
              name={`options${index}`}
            >
              <Msg id={item.titleKey} />
            </Checkbox>
            <div className="code-coding-checklist-panel__doc">
              <p>{item.subtitleKey && <Msg id={item.subtitleKey} />}</p>
              <p className="code-coding-checklist-panel__doc-link">
                {item.linkKey && (
                  <>
                    <JumpTo
                      to={Message.getMessageByKeyAndLocale(item.linkKey, "ja")}
                    >
                      [日本語]
                    </JumpTo>
                    <JumpTo
                      to={Message.getMessageByKeyAndLocale(item.linkKey, "en")}
                    >
                      [English]
                    </JumpTo>
                  </>
                )}
              </p>
            </div>
          </FormGroup>
        ))}
      </Form>
    </div>
  );
};
